export default __webpack_public_path__ + "static/media/4.c28d2209.png";